module.exports = {"back-to-blog-list":"Back to blog list","related":"Related articles","see-all":"See all posts","subscribe":{"title":"Sign up for our email updates <span class='no-break-text'>and stay updated</span>"},"download-free-guide":"Download our FREE guide!","tags":"Tags"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/blog-post.json
// module id = 7Kxc
// module chunks = 0